export default class WeightRule {
    isCustomOptionAllowed: boolean = false;
    minWeight: number = 0;
    maxWeight: number = 0;
    options: Array<number> = [];

    static fetchWeightRuleObjectFromJson(weightRule: any): WeightRule {
        var weightRuleObject = new WeightRule();

        weightRuleObject.isCustomOptionAllowed = weightRule.isCustomAllowed ?? false;
        weightRuleObject.minWeight = weightRule.minWeight ?? 0;
        weightRuleObject.maxWeight = weightRule.maxWeight ?? 0;
        weightRuleObject.options = Array.isArray(weightRule.options) ? weightRule.options.map((option: any) => Number(option)) : [];

        return weightRuleObject;
    }
}
